const initState = {
    eventID: null,
    error: null
}

const UserReducer = (state = initState, action) => {
    console.log()
    switch (action.type) {
        case 'CREATE_SUCCESS':
            return {...state, eventID: action.data};
        case 'CREATE_ERROR':
            return {...state, error: action.error};
        default:
            return state;
    }
}

export default UserReducer